<template>
    <div class="">
        <div class="flex space-x-4 mb-2">
            <h3 class="w-25">
                Titre:
            </h3>
            <input
                class="h-[2rem] w-[50%] rounded-lg focus:outline-none border-none"
                v-model="action.title"
                placeholder="Titre"/>
        </div>
        <div class="flex space-x-4 mb-2">
            <h3 class="w-25">
                Description:
            </h3>
            <textarea
                class="h-[2rem] w-[50%] rounded-lg focus:outline-none border-none"
                v-model="action.description"
                rows="3"
                placeholder="Description">
            </textarea>
        </div>
        <div class="mb-2">
            <h3>
                Schémas:
            </h3>
            
            <div v-for="(schema, i) in action.schemas" :key="'schema-' + i">
                <div class="flex">
                    <div class="w-25"></div>

                    <input
                    class="h-[2rem] w-[25%] rounded-lg focus:outline-none border-none"
                    v-model="action.schemas[i]"
                    placeholder="schema"/>
                    <span>
                        <b-button
                            class=""
                            @click="() => action.schemas.splice(i, 1)">
                            <i class="fas fa-trash"></i>
                        </b-button>
                    </span>
                </div>
            </div>
            <b-button
                @click="() => action.schemas.push('')"
                variant="primary">
                <i class="fas fa-plus"></i>
            </b-button>
        </div>

        <div class="flex space-x-4 mb-2">
            <h3 class="w-25">
                Icône:
            </h3>
            <input
                class="h-[2rem] w-[25%] rounded-lg focus:outline-none border-none"
                v-model="action.icon"
                placeholder="Icone (fontawesome v5)"/>
        </div>

        <div class="flex space-x-4 mb-2">
            <h3 class="w-25">
                Image:
            </h3>
            <input
                class="h-[2rem] w-[25%] rounded-lg focus:outline-none border-none"
                v-model="action.image"
                placeholder="Image (url)"/>
        </div>

        <!-- TODO ajouter une champ niveau ou "tiers" (petit chantier, changer les routes back + hermes) -->

        <div class="flex space-x-2">
            <b-button
                @click="() => saveAction()"
                variant="primary">
                Save
            </b-button>
            <b-button
                @click="() => $emit('cancelEdit')">
                Cancel
            </b-button>
        </div>
    </div>

</template>

<script>
	var clone = require("clone");

    export default {
        name: "action_editor",
        props: {
            currentParent: "",
        },
        data: function () {
            return {
                action: {
                    title: "",
                    description: "",
                    schemas: [],
                    icon: "",
                    image: ""
                }
            };
		},
        computed: {
        },
		methods: {
            loadEditor: function(actionData) {
                this.action = clone(actionData);
            },
            saveAction: function () {
                if (this.currentParent.length > 0)
                    this.action.isChild = true;

                this.$emit("save-action", this.action);
                this.action = {
                    title: "",
                    description: "",
                    schemas: [],
                    icon: ""
                };
            },
		},
		mounted: function () {

		},
    }


</script>